module.exports = __webpack_public_path__ + "img/beacon-antenna.344632a0.png";